import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Tile = ({ tile, index, isVisible, scrollProgress }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(tile.route);
  };

  // Define edge positions for each tile based on edgePosition property
  const getEdgePosition = (edgePosition) => {
    const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;
    const screenHeight = typeof window !== 'undefined' ? window.innerHeight : 800;
    
    switch (edgePosition) {
      case 'top-left':
        return { x: -screenWidth * 0.8, y: -screenHeight * 0.8 };
      case 'top-center':
        return { x: 0, y: -screenHeight * 0.8 };
      case 'top-right':
        return { x: screenWidth * 0.6, y: -screenHeight * 0.8 };
      case 'top-right-edge':
        return { x: screenWidth * 0.8, y: -screenHeight * 0.8 };
      case 'bottom-left':
        return { x: -screenWidth * 0.8, y: screenHeight * 0.8 };
      case 'left-edge':
        return { x: -screenWidth * 0.8, y: 0 };
      case 'bottom-center':
        return { x: 0, y: screenHeight * 0.8 };
      case 'bottom-right':
        return { x: screenWidth * 0.8, y: screenHeight * 0.8 };
      default:
        return { x: 0, y: 0 };
    }
  };

  const edgePos = getEdgePosition(tile.edgePosition);
  
  // Calculate animation values based on scroll progress
  const currentX = edgePos.x * (1 - scrollProgress);
  const currentY = edgePos.y * (1 - scrollProgress);
  const currentScale = 0.3 + (scrollProgress * 0.7);
  const currentOpacity = scrollProgress;

  return (
    <motion.button
      initial={{ 
        opacity: 0, 
        x: edgePos.x, 
        y: edgePos.y,
        scale: 0.3
      }}
      animate={{ 
        opacity: isVisible ? currentOpacity : 0, 
        x: isVisible ? currentX : edgePos.x, 
        y: isVisible ? currentY : edgePos.y,
        scale: isVisible ? currentScale : 0.3
      }}
      transition={{ 
        duration: 0.1,
        ease: "easeOut"
      }}
      className="w-full h-full rounded-lg flex items-start justify-start p-4 transition-all duration-300 group"
      style={{ 
        background: isHovered ? '#000000' : tile.gradient,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <span 
        className={`whitespace-pre-line transition-colors duration-0 font-bayon text-tile-title ${
          isHovered ? 'text-white' : 'text-black'
        }`}
        style={{ 
          textAlign: 'left',
          display: 'block',
          width: '100%',
          lineHeight: '52px'
        }}
      >
        {tile.title}
      </span>
    </motion.button>
  );
};

export default Tile;
